import React from 'react';
import Image from 'next/image';
import { css, cx } from 'styled-system/css';

import { Float } from '@shaojiang/components/motion';
import { type Pose, POSES } from '@shaojiang/data/site';
import type { Tone } from '@shaojiang/theme/preset/recipes/site/tones';

const discs: Record<Tone, string> = {
  cobalt: css({ bg: 'tone.cobalt.bg' }),
  tomato: css({ bg: 'tone.tomato.bg' }),
  leaf: css({ bg: 'tone.leaf.bg' }),
  sun: css({ bg: 'tone.sun.bg' }),
  sky: css({ bg: 'tone.sky.bg' }),
  blush: css({ bg: 'tone.blush.bg' }),
};

interface PortraitProps {
  pose: Pose;
  /** Color of the disc behind */
  tone: Tone;
  className?: string;
  /** Bob gently (default) */
  float?: boolean;
  alt?: string;
  sizes?: string;
  priority?: boolean;
}

/** One of the illustrated poses standing on a colored disc. Size it with `className`. */
export function Portrait({
  pose,
  tone,
  className,
  float = true,
  alt = '',
  sizes = '320px',
  priority,
}: PortraitProps) {
  const image = (
    <Image
      src={POSES[pose]}
      alt={alt}
      fill
      sizes={sizes}
      priority={priority}
      className={css({ objectFit: 'contain', objectPosition: 'bottom' })}
    />
  );
  return (
    <div className={cx(css({ position: 'relative', aspectRatio: '1' }), className)}>
      <div
        className={cx(
          css({ position: 'absolute', inset: '12% 7% 0', borderRadius: 'full' }),
          discs[tone],
        )}
      />
      {float ? (
        <Float className={css({ position: 'absolute', inset: '0' })}>{image}</Float>
      ) : (
        <div className={css({ position: 'absolute', inset: '0' })}>{image}</div>
      )}
    </div>
  );
}
